import { TZDate } from "@date-fns/tz";
import { set } from "date-fns";

export const CALENDAR_DEFAULT_TIMEZONE = "Europe/London";

/** Keep instants as instants, but interpret date-only/wall-clock values in the view's zone. */
export function calendarZonedDate(value: string | number | Date, timezone = CALENDAR_DEFAULT_TIMEZONE): TZDate {
  if (typeof value === "string") {
    const wall = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?)?$/.exec(value);
    if (wall) return new TZDate(Number(wall[1]), Number(wall[2]) - 1, Number(wall[3]), Number(wall[4] ?? 0), Number(wall[5] ?? 0), Number(wall[6] ?? 0), Number((wall[7] ?? "0").padEnd(3, "0")), timezone);
  }
  return typeof value === "string"
    ? new TZDate(value, timezone)
    : new TZDate(value instanceof Date ? value.getTime() : value, timezone);
}

/** Grid coordinates represent local clock minutes, not elapsed time since midnight. */
export function calendarAtMinutes(day: Date, minutes: number): Date {
  return set(day, { hours: Math.floor(minutes / 60), minutes: minutes % 60, seconds: 0, milliseconds: 0 });
}
